import React from "react";
import OrderDeliveryListPageContainer from "./OrderDeliveryListPageContainer";

export class OrderDeliveryListPage extends React.Component {
  render() {
    return <OrderDeliveryListPageContainer {...this.props} />;
  }
}
